"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.promise.finally");

var _readOnlyError = require("/opt/build/repo/node_modules/@babel/runtime/helpers/readOnlyError");

require("core-js/modules/es6.array.sort");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.keys");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.from");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.seal");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.object.define-property");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e8) { throw _e8; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e9) { didErr = true; err = _e9; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function e(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t = e(require("react")),
    n = e(require("react-dom"));
var o = {
  setByAddingToSet: function setByAddingToSet(e, t) {
    var n = new Set(e);
    return n.add(t), n;
  },
  setByDeletingFromSet: function setByDeletingFromSet(e, t) {
    var n = new Set(e);
    return n["delete"](t), n;
  },
  mapBySettingInMap: function mapBySettingInMap(e, t, n) {
    var o = new Map(e);
    return o.set(t, n), o;
  },
  mapByUpdatingInMap: function mapByUpdatingInMap(e, t, n) {
    var o = new Map(e);
    return o.set(t, n(o.get(t))), o;
  },
  mapByDeletingFromMap: function mapByDeletingFromMap(e, t) {
    var n = new Map(e);
    return n["delete"](t), n;
  }
};

var r = function r(e) {
  var t, n;
  var o = null !== (n = (null != e ? null !== (t = e.ownerDocument) && void 0 !== t ? t : e : document).defaultView) && void 0 !== n ? n : window;
  return !(null == e || !("function" == typeof o.Node ? e instanceof o.Node : "object" == typeof e && "number" == typeof e.nodeType && "string" == typeof e.nodeName));
};

var a = function a(e) {
  return !!e && "function" == typeof e.then;
};

var s = function e(t) {
  if ("object" == typeof t && !function (e) {
    if (null === e || "object" != typeof e) return !0;

    switch (typeof e.$$typeof) {
      case "symbol":
      case "number":
        return !0;
    }

    return null != e["@@__IMMUTABLE_ITERABLE__@@"] || null != e["@@__IMMUTABLE_KEYED__@@"] || null != e["@@__IMMUTABLE_INDEXED__@@"] || null != e["@@__IMMUTABLE_ORDERED__@@"] || null != e["@@__IMMUTABLE_RECORD__@@"] || !!r(e) || !!a(e);
  }(t)) {
    Object.freeze(t);

    for (var _n in t) {
      t.hasOwnProperty(_n) && e(t[_n]);
    }

    Object.seal(t);
  }
};

var u = function u(e, t) {
  if (null != e) return e;
  throw new Error(null != t ? t : "Got unexpected null or undefined");
};

var i = {
  getValue: function getValue() {
    if ("hasValue" !== this.state) throw this.contents;
    return this.contents;
  },
  toPromise: function toPromise() {
    return "hasValue" === this.state ? Promise.resolve(this.contents) : "hasError" === this.state ? Promise.reject(this.contents) : this.contents;
  },
  valueMaybe: function valueMaybe() {
    return "hasValue" === this.state ? this.contents : void 0;
  },
  valueOrThrow: function valueOrThrow() {
    if ("hasValue" !== this.state) throw new Error("Loadable expected value, but in \"".concat(this.state, "\" state"));
    return this.contents;
  },
  errorMaybe: function errorMaybe() {
    return "hasError" === this.state ? this.contents : void 0;
  },
  errorOrThrow: function errorOrThrow() {
    if ("hasError" !== this.state) throw new Error("Loadable expected error, but in \"".concat(this.state, "\" state"));
    return this.contents;
  },
  promiseMaybe: function promiseMaybe() {
    return "loading" === this.state ? this.contents : void 0;
  },
  promiseOrThrow: function promiseOrThrow() {
    if ("loading" !== this.state) throw new Error("Loadable expected promise, but in \"".concat(this.state, "\" state"));
    return this.contents;
  },
  map: function map(e) {
    var _this = this;

    if ("hasError" === this.state) return this;
    if ("hasValue" === this.state) try {
      var _t2 = e(this.contents);

      return a(_t2) ? d(_t2) : c(_t2);
    } catch (t) {
      return a(t) ? d(t.next(function () {
        return e(_this.contents);
      })) : l(t);
    }
    if ("loading" === this.state) return d(this.contents.then(e)["catch"](function (t) {
      if (a(t)) return t.then(function () {
        return e(_this.contents);
      });
      throw t;
    }));
    throw new Error("Invalid Loadable state");
  }
};

function c(e) {
  return Object.freeze(_objectSpread({
    state: "hasValue",
    contents: e
  }, i));
}

function l(e) {
  return Object.freeze(_objectSpread({
    state: "hasError",
    contents: e
  }, i));
}

function d(e) {
  return Object.freeze(_objectSpread({
    state: "loading",
    contents: e
  }, i));
}

var f = {
  loadableWithValue: c,
  loadableWithError: l,
  loadableWithPromise: d,
  loadableLoading: function loadableLoading() {
    return d(new Promise(function () {}));
  },
  loadableAll: function loadableAll(e) {
    return e.every(function (e) {
      return "hasValue" === e.state;
    }) ? c(e.map(function (e) {
      return e.contents;
    })) : e.some(function (e) {
      return "hasError" === e.state;
    }) ? l(u(e.find(function (e) {
      return "hasError" === e.state;
    }), "Invalid loadable passed to loadableAll").contents) : d(Promise.all(e.map(function (e) {
      return e.contents;
    })));
  }
};

var p = function p(e) {
  _classCallCheck(this, p);

  var t, n, o;
  o = void 0, (n = "key") in (t = this) ? Object.defineProperty(t, n, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = o, this.key = e;
};

var S = {
  AbstractRecoilValue: p,
  RecoilState: /*#__PURE__*/function (_p) {
    _inherits(RecoilState, _p);

    var _super = _createSuper(RecoilState);

    function RecoilState() {
      _classCallCheck(this, RecoilState);

      return _super.apply(this, arguments);
    }

    return RecoilState;
  }(p),
  RecoilValueReadOnly: /*#__PURE__*/function (_p2) {
    _inherits(RecoilValueReadOnly, _p2);

    var _super2 = _createSuper(RecoilValueReadOnly);

    function RecoilValueReadOnly() {
      _classCallCheck(this, RecoilValueReadOnly);

      return _super2.apply(this, arguments);
    }

    return RecoilValueReadOnly;
  }(p)
},
    b = S.AbstractRecoilValue,
    h = S.RecoilState,
    m = S.RecoilValueReadOnly,
    R = Object.freeze({
  __proto__: null,
  AbstractRecoilValue: b,
  RecoilState: h,
  RecoilValueReadOnly: m
});

var v = function v() {
  _classCallCheck(this, v);
};

var y = new v();

var g = /*#__PURE__*/function (_Error) {
  _inherits(g, _Error);

  var _super3 = _createSuper(g);

  function g(e) {
    _classCallCheck(this, g);

    return _super3.call(this, "Tried to set the value of Recoil selector ".concat(e, " using an updater function, but it is an async selector in a pending or error state; this is not supported."));
  }

  return g;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var w = new Map();

var V = /*#__PURE__*/function (_Error2) {
  _inherits(V, _Error2);

  var _super4 = _createSuper(V);

  function V() {
    _classCallCheck(this, V);

    return _super4.apply(this, arguments);
  }

  return V;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var T = {
  nodes: w,
  registerNode: function registerNode(e) {
    if (w.has(e.key)) {
      e.key;
    }

    return w.set(e.key, e), null == e.set ? new R.RecoilValueReadOnly(e.key) : new R.RecoilState(e.key);
  },
  getNode: function getNode(e) {
    var t = w.get(e);
    if (null == t) throw new V("Missing definition for RecoilValue: \"".concat(e, "\"\""));
    return t;
  },
  NodeMissingError: V,
  DefaultValue: v,
  DEFAULT_VALUE: y,
  RecoilValueNotReady: g
};
var A = {
  trace: function trace(e, t, n) {
    return n();
  },
  wrap: function wrap(e) {
    return e;
  }
};
var E = o.mapByDeletingFromMap,
    M = o.mapBySettingInMap,
    N = o.mapByUpdatingInMap,
    _ = o.setByAddingToSet,
    L = T.getNode,
    k = Object.freeze(new Map()),
    B = Object.freeze(new Set());

var U = /*#__PURE__*/function (_Error3) {
  _inherits(U, _Error3);

  var _super5 = _createSuper(U);

  function U() {
    _classCallCheck(this, U);

    return _super5.apply(this, arguments);
  }

  return U;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function x(e, t, n) {
  return L(n).get(e, t);
}

var C = 0;
var O = {
  getNodeLoadable: x,
  peekNodeLoadable: function peekNodeLoadable(e, t, n) {
    return x(e, t, n)[1];
  },
  setNodeValue: function setNodeValue(e, t, n, o) {
    var r = L(n);
    if (null == r.set) throw new U("Attempt to set read-only RecoilValue: " + n);

    var _r$set = r.set(e, t, o),
        _r$set2 = _slicedToArray(_r$set, 2),
        a = _r$set2[0],
        s = _r$set2[1];

    return [a, s];
  },
  setUnvalidatedAtomValue: function setUnvalidatedAtomValue(e, t, n) {
    return _objectSpread(_objectSpread({}, e), {}, {
      atomValues: E(e.atomValues, t),
      nonvalidatedAtoms: M(e.nonvalidatedAtoms, t, n),
      dirtyAtoms: _(e.dirtyAtoms, t)
    });
  },
  subscribeComponentToNode: function subscribeComponentToNode(e, t, n) {
    var o = C++;
    return [_objectSpread(_objectSpread({}, e), {}, {
      nodeToComponentSubscriptions: N(e.nodeToComponentSubscriptions, t, function (e) {
        return M(null != e ? e : k, o, ["TODO debug name", n]);
      })
    }), function (e) {
      return _objectSpread(_objectSpread({}, e), {}, {
        nodeToComponentSubscriptions: N(e.nodeToComponentSubscriptions, t, function (e) {
          return E(null != e ? e : k, o);
        })
      });
    }];
  },
  fireNodeSubscriptions: function fireNodeSubscriptions(e, t, n) {
    var o;

    var r = "enqueue" === n && null !== (o = e.getState().nextTree) && void 0 !== o ? o : e.getState().currentTree,
        a = function (e, t) {
      var n = new Set(),
          o = new Set(),
          r = Array.from(t);

      for (var _t3 = r.pop(); _t3; _t3 = r.pop()) {
        var a;
        n.add(_t3), o.add(_t3);

        var _s = null !== (a = e.nodeToNodeSubscriptions.get(_t3)) && void 0 !== a ? a : B;

        var _iterator = _createForOfIteratorHelper(_s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e2 = _step.value;
            o.has(_e2) || r.push(_e2);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return n;
    }(r, t);

    var _iterator2 = _createForOfIteratorHelper(a),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _t4 = _step2.value;
        var s;
        (null !== (s = r.nodeToComponentSubscriptions.get(_t4)) && void 0 !== s ? s : []).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              t = _ref2[0],
              o = _ref2[1];

          "enqueue" === n ? e.getState().queuedComponentCallbacks.push(o) : o(r);
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    A.trace("value became available, waking components", Array.from(t).join(", "), function () {
      var t = e.getState().suspendedComponentResolvers;
      t.forEach(function (e) {
        return e();
      }), t.clear();
    });
  },
  detectCircularDependencies: function e(t, n) {
    if (!n.length) return;
    var o = n[n.length - 1],
        r = t.nodeToNodeSubscriptions.get(o);
    if (!(null == r ? void 0 : r.size)) return;
    var a = n[0];
    if (r.has(a)) throw new Error("Recoil selector has circular dependencies: " + [].concat(_toConsumableArray(n), [a]).reverse().join(" → "));

    var _iterator3 = _createForOfIteratorHelper(r),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _o = _step3.value;
        e(t, [].concat(_toConsumableArray(n), [_o]));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
};
var D = O.getNodeLoadable,
    I = O.peekNodeLoadable,
    j = O.setNodeValue,
    P = O.setUnvalidatedAtomValue,
    z = O.subscribeComponentToNode,
    q = R.RecoilValue,
    F = R.AbstractRecoilValue,
    W = R.RecoilValueReadOnly,
    $ = R.RecoilState;
var G = {
  AbstractRecoilValue: F,
  RecoilState: $,
  peekRecoilValueAsLoadable: function peekRecoilValueAsLoadable(e, _ref3) {
    var t = _ref3.key;
    var n = e.getState().currentTree;
    return I(e, n, t);
  },
  getRecoilValueAsLoadable: function getRecoilValueAsLoadable(e, _ref4) {
    var t = _ref4.key;
    var n;
    return A.trace("get RecoilValue", t, function () {
      return e.replaceState(A.wrap(function (o) {
        var _D = D(e, o, t),
            _D2 = _slicedToArray(_D, 2),
            r = _D2[0],
            a = _D2[1];

        return n = a, r;
      }));
    }), n;
  },
  setRecoilValue: function setRecoilValue(e, _ref5, n) {
    var t = _ref5.key;
    A.trace("set RecoilValue", t, function () {
      return e.replaceState(A.wrap(function (o) {
        var _j = j(e, o, t, n),
            _j2 = _slicedToArray(_j, 2),
            r = _j2[0],
            a = _j2[1];

        return e.fireNodeSubscriptions(a, "enqueue"), r;
      }));
    });
  },
  setUnvalidatedRecoilValue: function setUnvalidatedRecoilValue(e, _ref6, n) {
    var t = _ref6.key;
    A.trace("set unvalidated persisted atom", t, function () {
      return e.replaceState(A.wrap(function (o) {
        var r = P(o, t, n);
        return e.fireNodeSubscriptions(new Set([t]), "enqueue"), r;
      }));
    });
  },
  subscribeToRecoilValue: function subscribeToRecoilValue(e, _ref7, n) {
    var t = _ref7.key;
    var o, r;
    return A.trace("subscribe component to RecoilValue", t, function () {
      return e.replaceState(A.wrap(function (e) {
        var _z, _z2;

        return (_z = z(e, t, n), _z2 = _slicedToArray(_z, 2), o = _z2[0], r = _z2[1], _z), o;
      }));
    }), {
      release: function release(e) {
        return e.replaceState(r);
      }
    };
  },
  isRecoilValue: function isRecoilValue(e) {
    return e instanceof $ || e instanceof W;
  }
};
var K = o.mapByDeletingFromMap,
    X = o.mapBySettingInMap,
    Y = o.setByAddingToSet,
    H = f.loadableWithValue,
    J = T.DEFAULT_VALUE,
    Q = T.DefaultValue,
    Z = T.registerNode,
    ee = G.isRecoilValue;

function te(e) {
  var t = e["default"],
      n = _objectWithoutProperties(e, ["default"]);

  return ee(t) || a(t) ? function (e) {
    var t = te(_objectSpread(_objectSpread({}, e), {}, {
      "default": J,
      persistence_UNSTABLE: void 0 === e.persistence_UNSTABLE ? void 0 : _objectSpread(_objectSpread({}, e.persistence_UNSTABLE), {}, {
        validator: function validator(t) {
          return t instanceof Q ? t : u(e.persistence_UNSTABLE).validator(t, J);
        }
      })
    }));
    return selector({
      key: e.key + "__withFallback",
      get: function get(_ref8) {
        var n = _ref8.get;
        var o = n(t);
        return o instanceof Q ? e["default"] : o;
      },
      set: function set(_ref9, n) {
        var e = _ref9.set;
        return e(t, n);
      },
      dangerouslyAllowMutability: e.dangerouslyAllowMutability
    });
  }(_objectSpread(_objectSpread({}, n), {}, {
    "default": t
  })) : function (e) {
    var t = e.key,
        n = e.persistence_UNSTABLE;
    return Z({
      key: t,
      options: e,
      get: function get(o, r) {
        if (r.atomValues.has(t)) return [r, u(r.atomValues.get(t))];

        if (r.nonvalidatedAtoms.has(t)) {
          if (null == n) return [r, H(e["default"])];

          var _o2 = r.nonvalidatedAtoms.get(t),
              _a = n.validator(_o2, J);

          return _a instanceof Q ? [_objectSpread(_objectSpread({}, r), {}, {
            nonvalidatedAtoms: K(r.nonvalidatedAtoms, t)
          }), H(e["default"])] : [_objectSpread(_objectSpread({}, r), {}, {
            atomValues: X(r.atomValues, t, H(_a)),
            nonvalidatedAtoms: K(r.nonvalidatedAtoms, t)
          }), H(_a)];
        }

        return [r, H(e["default"])];
      },
      set: function set(n, o, r) {
        return !0 !== e.dangerouslyAllowMutability && s(r), [_objectSpread(_objectSpread({}, o), {}, {
          dirtyAtoms: Y(o.dirtyAtoms, t),
          atomValues: r instanceof Q ? K(o.atomValues, t) : X(o.atomValues, t, H(r)),
          nonvalidatedAtoms: K(o.nonvalidatedAtoms, t)
        }), new Set([t])];
      }
    });
  }(_objectSpread(_objectSpread({}, n), {}, {
    "default": t
  }));
}

var ne = te;
var oe = {
  enqueueExecution: function enqueueExecution(e, t) {
    t();
  }
};
var re = t.useContext,
    ae = t.useEffect,
    se = t.useRef,
    ue = t.useState,
    ie = O.fireNodeSubscriptions,
    ce = O.setNodeValue,
    le = O.setUnvalidatedAtomValue;

function de() {
  throw new Error("This component must be used inside a <RecoilRoot> component.");
}

var fe = Object.freeze({
  getState: de,
  replaceState: de,
  subscribeToTransactions: de,
  addTransactionMetadata: de,
  fireNodeSubscriptions: de
});

function pe(e) {
  null === e.nextTree && (e.nextTree = _objectSpread(_objectSpread({}, e.currentTree), {}, {
    dirtyAtoms: new Set(),
    transactionMetadata: {}
  }));
}

var Se = t.createContext({
  current: fe
}),
    be = function be() {
  return re(Se);
};

function he(e) {
  var t = be(),
      _ue = ue([]),
      _ue2 = _slicedToArray(_ue, 2),
      n = _ue2[0],
      o = _ue2[1];

  return e.setNotifyBatcherOfChange(function () {
    return o({});
  }), ae(function () {
    oe.enqueueExecution("Batcher", function () {
      var e = t.current.getState(),
          n = e.currentTree,
          o = e.nextTree;
      null !== o && (o.dirtyAtoms.size && e.transactionSubscriptions.forEach(function (e) {
        return e(t.current, n);
      }), e.queuedComponentCallbacks.forEach(function (e) {
        return e(o);
      }), e.queuedComponentCallbacks.splice(0, e.queuedComponentCallbacks.length), e.currentTree = o, e.nextTree = null);
    });
  }), null;
}

function me(e, t) {
  var n = {
    currentTree: {
      isSnapshot: !1,
      transactionMetadata: {},
      atomValues: new Map(),
      nonvalidatedAtoms: new Map(),
      dirtyAtoms: new Set(),
      nodeDeps: new Map(),
      nodeToNodeSubscriptions: new Map(),
      nodeToComponentSubscriptions: new Map()
    },
    nextTree: null,
    transactionSubscriptions: new Map(),
    queuedComponentCallbacks: [],
    suspendedComponentResolvers: new Set()
  };
  return t && t({
    set: function set(t, o) {
      n.currentTree = ce(e, n.currentTree, t.key, o)[0];
    },
    setUnvalidatedAtomValues: function setUnvalidatedAtomValues(e) {
      e.forEach(function (e, t) {
        n.currentTree = le(n.currentTree, t, e);
      });
    }
  }), n;
}

var Re = 0;
var ve = {
  useStoreRef: be,
  RecoilRoot: function RecoilRoot(_ref10) {
    var e = _ref10.initializeState,
        n = _ref10.children;
    var o;
    var r = se(null),
        a = {
      getState: function getState() {
        return o.current;
      },
      replaceState: function replaceState(e) {
        var t = s.current.getState();
        pe(t);
        var n = u(t.nextTree),
            o = e(n);
        o !== n && (t.nextTree = o, u(r.current)());
      },
      subscribeToTransactions: function subscribeToTransactions(e) {
        var t = Re++;
        return s.current.getState().transactionSubscriptions.set(t, e), {
          release: function release() {
            s.current.getState().transactionSubscriptions["delete"](t);
          }
        };
      },
      addTransactionMetadata: function addTransactionMetadata(e) {
        pe(s.current.getState());

        for (var _i = 0, _Object$keys = Object.keys(e); _i < _Object$keys.length; _i++) {
          var _t5 = _Object$keys[_i];
          u(s.current.getState().nextTree).transactionMetadata[_t5] = e[_t5];
        }
      },
      fireNodeSubscriptions: function fireNodeSubscriptions(e, t) {
        ie(s.current, e, t);
      }
    },
        s = se(a);
    return o = se(me(a, e)), t.createElement(Se.Provider, {
      value: s
    }, t.createElement(he, {
      setNotifyBatcherOfChange: function setNotifyBatcherOfChange(e) {
        r.current = e;
      }
    }), n);
  }
};

var ye = function ye(e) {
  var n = new Set();

  for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    t[_key - 1] = arguments[_key];
  }

  var _iterator4 = _createForOfIteratorHelper(e),
      _step4;

  try {
    e: for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _o3 = _step4.value;

      var _iterator5 = _createForOfIteratorHelper(t),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _e3 = _step5.value;
          if (_e3.has(_o3)) continue e;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      n.add(_o3);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return n;
};

var ge = function ge(e, t) {
  var n = new Map();

  var _iterator6 = _createForOfIteratorHelper(e),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _step6$value = _slicedToArray(_step6.value, 2),
          _o4 = _step6$value[0],
          _r = _step6$value[1];

      t(_r, _o4) && n.set(_o4, _r);
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return n;
};

var we = function we(e) {
  var n = new Set();

  for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    t[_key2 - 1] = arguments[_key2];
  }

  var _iterator7 = _createForOfIteratorHelper(e),
      _step7;

  try {
    e: for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _o5 = _step7.value;

      var _iterator8 = _createForOfIteratorHelper(t),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _e4 = _step8.value;
          if (!_e4.has(_o5)) continue e;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      n.add(_o5);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return n;
};

var Ve = function Ve(e, t) {
  if (!e) throw new Error(t);
};

var Te = function Te(e, t) {
  var n = new Map();
  return e.forEach(function (e, o) {
    n.set(o, t(e, o));
  }), n;
};

var Ae = function Ae() {
  var t = new Map();

  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }

  for (var _n2 = 0; _n2 < e.length; _n2++) {
    var _o6 = e[_n2].keys();

    var _r2 = void 0;

    for (; !(_r2 = _o6.next()).done;) {
      t.set(_r2.value, e[_n2].get(_r2.value));
    }
  }

  return t;
};

var Ee = t.useCallback,
    Me = t.useEffect,
    Ne = t.useMemo,
    _e = t.useRef,
    Le = t.useState,
    ke = o.setByAddingToSet,
    Be = O.getNodeLoadable,
    Ue = O.peekNodeLoadable,
    xe = O.setNodeValue,
    Ce = T.DEFAULT_VALUE,
    Oe = T.RecoilValueNotReady,
    De = T.getNode,
    Ie = T.nodes,
    je = ve.useStoreRef,
    Pe = G.AbstractRecoilValue,
    ze = G.getRecoilValueAsLoadable,
    qe = G.setRecoilValue,
    Fe = G.setUnvalidatedRecoilValue,
    We = G.subscribeToRecoilValue;

function $e(e, t) {
  return {
    isSnapshot: t.isSnapshot,
    transactionMetadata: _objectSpread({}, e.transactionMetadata),
    atomValues: new Map(e.atomValues),
    nonvalidatedAtoms: new Map(e.nonvalidatedAtoms),
    dirtyAtoms: new Set(e.dirtyAtoms),
    nodeDeps: new Map(e.nodeDeps),
    nodeToNodeSubscriptions: Te(e.nodeToNodeSubscriptions, function (e) {
      return new Set(e);
    }),
    nodeToComponentSubscriptions: Te(e.nodeToComponentSubscriptions, function (e) {
      return new Map(e);
    })
  };
}

function Ge(e, t, n, o) {
  if ("function" == typeof o) {
    var _r3 = Ue(e, t, n.key);

    if ("loading" === _r3.state) throw new Oe(n.key);
    if ("hasError" === _r3.state) throw _r3.contents;
    return o(_r3.contents);
  }

  return o;
}

function Ke() {
  var e = je(),
      _Le = Le([]),
      _Le2 = _slicedToArray(_Le, 2),
      t = _Le2[0],
      n = _Le2[1],
      o = _e(new Set());

  o.current = new Set();

  var r = _e(new Set()),
      a = _e(new Map()),
      s = Ee(function (t) {
    var n = a.current.get(t);
    n && (n.release(e.current), a.current["delete"](t));
  }, [e, a]);

  return Me(function () {
    var t = e.current;

    function u(e, t) {
      a.current.has(t) && n([]);
    }

    ye(o.current, r.current).forEach(function (e) {
      if (a.current.has(e)) return;
      var n = We(t, new Pe(e), function (t) {
        A.trace("RecoilValue subscription fired", e, function () {
          u(0, e);
        });
      });
      a.current.set(e, n), A.trace("initial update on subscribing", e, function () {
        u(t.getState(), e);
      });
    }), ye(r.current, o.current).forEach(function (e) {
      s(e);
    }), r.current = o.current;
  }), Me(function () {
    var e = a.current;
    return function () {
      return e.forEach(function (e, t) {
        return s(t);
      });
    };
  }, [s]), Ne(function () {
    function t(t) {
      return function (n) {
        var o;
        var r = e.current.getState(),
            a = Ge(e.current, null !== (o = r.nextTree) && void 0 !== o ? o : r.currentTree, t, n);
        qe(e.current, t, a);
      };
    }

    function n(t) {
      return o.current.has(t.key) || (o.current = ke(o.current, t.key)), ze(e.current, t);
    }

    function r(t) {
      return function (e, t, n) {
        if ("hasValue" === e.state) return e.contents;

        if ("loading" === e.state) {
          throw new Promise(function (e) {
            n.current.getState().suspendedComponentResolvers.add(e);
          });
        }

        throw "hasError" === e.state ? e.contents : new Error("Invalid value of loadable atom \"".concat(t.key, "\""));
      }(n(t), t, e);
    }

    return {
      getRecoilValue: r,
      getRecoilValueLoadable: n,
      getRecoilState: function getRecoilState(e) {
        return [r(e), t(e)];
      },
      getRecoilStateLoadable: function getRecoilStateLoadable(e) {
        return [n(e), t(e)];
      },
      getSetRecoilState: t,
      getResetRecoilState: function getResetRecoilState(t) {
        return function () {
          return qe(e.current, t, Ce);
        };
      }
    };
  }, [o, e]);
}

function Xe(e) {
  var t = je();
  Me(function () {
    return t.current.subscribeToTransactions(e).release;
  }, [e, t]);
}

function Ye(e) {
  var t = e.atomValues,
      n = Te(ge(t, function (e, t) {
    var n;
    var o = null === (n = De(t).options) || void 0 === n ? void 0 : n.persistence_UNSTABLE;
    return null != o && "none" !== o.type && "hasValue" === e.state;
  }), function (e) {
    return e.contents;
  });
  return Ae(e.nonvalidatedAtoms, n);
}

var He = function He() {
  _classCallCheck(this, He);
};

var Je = new He();
var Qe = {
  useRecoilCallback: function useRecoilCallback(e, t) {
    var o = je();
    return Ee(function () {
      for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        t[_key4] = arguments[_key4];
      }

      var r = $e(o.current.getState().currentTree, {
        isSnapshot: !0
      });

      function a(e) {
        var _Be, _Be2;

        var t;
        return (_Be = Be(o.current, r, e.key), _Be2 = _slicedToArray(_Be, 2), r = _Be2[0], t = _Be2[1], _Be), t;
      }

      function s(e) {
        return a(e).toPromise();
      }

      function u(e, t) {
        var n = Ge(o.current, r, e, t);
        qe(o.current, e, n);
      }

      function i(e) {
        qe(o.current, e, Ce);
      }

      var c = Je;
      return n.unstable_batchedUpdates(function () {
        c = e.apply(void 0, [{
          getPromise: s,
          getLoadable: a,
          set: u,
          reset: i
        }].concat(t));
      }), Ve(!(c instanceof He), "unstable_batchedUpdates should return immediately"), c;
    }, null != t ? [].concat(_toConsumableArray(t), [o]) : void 0);
  },
  useRecoilValue: function useRecoilValue(e) {
    return Ke().getRecoilValue(e);
  },
  useRecoilValueLoadable: function useRecoilValueLoadable(e) {
    return Ke().getRecoilValueLoadable(e);
  },
  useRecoilState: function useRecoilState(e) {
    var t = Ke(),
        _t$getRecoilState = t.getRecoilState(e),
        _t$getRecoilState2 = _slicedToArray(_t$getRecoilState, 1),
        n = _t$getRecoilState2[0];

    return [n, Ee(t.getSetRecoilState(e), [e])];
  },
  useRecoilStateLoadable: function useRecoilStateLoadable(e) {
    var t = Ke(),
        _t$getRecoilStateLoad = t.getRecoilStateLoadable(e),
        _t$getRecoilStateLoad2 = _slicedToArray(_t$getRecoilStateLoad, 1),
        n = _t$getRecoilStateLoad2[0];

    return [n, Ee(t.getSetRecoilState(e), [e])];
  },
  useSetRecoilState: function useSetRecoilState(e) {
    return Ee(Ke().getSetRecoilState(e), [e]);
  },
  useResetRecoilState: function useResetRecoilState(e) {
    return Ee(Ke().getResetRecoilState(e), [e]);
  },
  useRecoilInterface: Ke,
  useTransactionSubscription: Xe,
  useSnapshotWithStateChange: function useSnapshotWithStateChange(e) {
    var t = je();

    var n = function () {
      var _Le3 = Le(0),
          _Le4 = _slicedToArray(_Le3, 2),
          e = _Le4[0],
          t = _Le4[1];

      return Xe(Ee(function () {
        return t(function (e) {
          return e + 1;
        });
      }, [])), $e(je().current.getState().currentTree, {
        isSnapshot: !0
      });
    }();

    e(function (_ref11, o) {
      var e = _ref11.key;

      var _xe = xe(t.current, n, e, Ue(t.current, n, e).map(o));

      var _xe2 = _slicedToArray(_xe, 1);

      n = _xe2[0];
    });
    var o = Te(n.atomValues, function (e) {
      return e.contents;
    }),
        r = we(n.dirtyAtoms, new Set(o.keys()));
    return {
      atomValues: o,
      updatedAtoms: r
    };
  },
  useTransactionObservation: function useTransactionObservation(e) {
    Xe(Ee(function (t, n) {
      var o = t.getState().nextTree;
      o || (o = t.getState().currentTree);
      var r = Ye(o),
          a = Ye(n),
          s = Te(Ie, function (e) {
        var t, n, o, r, a, s;
        return {
          persistence_UNSTABLE: {
            type: null !== (t = null === (n = e.options) || void 0 === n || null === (o = n.persistence_UNSTABLE) || void 0 === o ? void 0 : o.type) && void 0 !== t ? t : "none",
            backButton: null !== (r = null === (a = e.options) || void 0 === a || null === (s = a.persistence_UNSTABLE) || void 0 === s ? void 0 : s.backButton) && void 0 !== r && r
          }
        };
      }),
          u = new Set(o.dirtyAtoms);
      e({
        atomValues: r,
        previousAtomValues: a,
        atomInfo: s,
        modifiedAtoms: u,
        transactionMetadata: _objectSpread({}, o.transactionMetadata)
      });
    }, [e]));
  },
  useGoToSnapshot: function useGoToSnapshot() {
    var e = je();
    return function (t) {
      n.unstable_batchedUpdates(function () {
        t.updatedAtoms.forEach(function (n) {
          qe(e.current, new Pe(n), t.atomValues.get(n));
        });
      });
    };
  },
  useSetUnvalidatedAtomValues: function useSetUnvalidatedAtomValues() {
    var e = je();
    return function (t) {
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      n.unstable_batchedUpdates(function () {
        e.current.addTransactionMetadata(o), t.forEach(function (t, n) {
          return Fe(e.current, new Pe(n), t);
        });
      });
    };
  }
};
var Ze = Symbol("ArrayKeyedMap"),
    et = new Map();

var tt = /*#__PURE__*/function () {
  function tt(e) {
    _classCallCheck(this, tt);

    if (this._base = new Map(), e instanceof tt) {
      var _iterator9 = _createForOfIteratorHelper(e.entries()),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _step9$value = _slicedToArray(_step9.value, 2),
              _t6 = _step9$value[0],
              _n3 = _step9$value[1];

          this.set(_t6, _n3);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    } else if (e) {
      var _iterator10 = _createForOfIteratorHelper(e),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _step10$value = _slicedToArray(_step10.value, 2),
              _t7 = _step10$value[0],
              _n4 = _step10$value[1];

          this.set(_t7, _n4);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }

    return this;
  }

  _createClass(tt, [{
    key: "get",
    value: function get(e) {
      var t = Array.isArray(e) ? e : [e];
      var n = this._base;
      return t.forEach(function (e) {
        var t;
        n = null !== (t = n.get(e)) && void 0 !== t ? t : et;
      }), void 0 === n ? void 0 : n.get(Ze);
    }
  }, {
    key: "set",
    value: function set(e, t) {
      var n = Array.isArray(e) ? e : [e];
      var o = this._base,
          r = o;
      return n.forEach(function (e) {
        r = o.get(e), r || (r = new Map(), o.set(e, r)), o = r;
      }), r.set(Ze, t), this;
    }
  }, {
    key: "delete",
    value: function _delete(e) {
      var t = Array.isArray(e) ? e : [e];
      var n = this._base,
          o = n;
      return t.forEach(function (e) {
        o = n.get(e), o || (o = new Map(), n.set(e, o)), n = o;
      }), o["delete"](Ze), this;
    }
  }, {
    key: "entries",
    value: function entries() {
      var e = [];
      return function t(n, o) {
        n.forEach(function (n, r) {
          r === Ze ? e.push([o, n]) : t(n, o.concat(r));
        });
      }(this._base, []), e.values();
    }
  }, {
    key: "toBuiltInMap",
    value: function toBuiltInMap() {
      return new Map(this.entries());
    }
  }]);

  return tt;
}();

var nt = tt;

var ot = function ot() {
  return new nt();
};

var rt = {
  startPerfBlock: function startPerfBlock(e) {
    return function () {};
  }
};

var at = function at(e, t, n) {
  var o = e.entries();
  var r = o.next();

  for (; !r.done;) {
    var _a2 = r.value;
    if (!t.call(n, _a2[1], _a2[0], e)) return !1;
    r = o.next();
  }

  return !0;
};

var st = function st(e, t) {
  return e.size === t.size && at(e, function (e) {
    return t.has(e);
  });
};

Object.freeze(new Set());
var ut = o.mapBySettingInMap,
    it = o.mapByUpdatingInMap,
    ct = o.setByAddingToSet,
    lt = o.setByDeletingFromSet,
    dt = O.detectCircularDependencies,
    ft = O.getNodeLoadable,
    pt = O.setNodeValue,
    St = f.loadableWithError,
    bt = f.loadableWithPromise,
    ht = f.loadableWithValue,
    mt = T.DEFAULT_VALUE,
    Rt = T.RecoilValueNotReady,
    vt = T.registerNode,
    yt = rt.startPerfBlock,
    gt = G.isRecoilValue,
    wt = Object.freeze(new Set());

function Vt(e) {
  var t = [];

  var _iterator11 = _createForOfIteratorHelper(Array.from(e.keys()).sort()),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var _n5 = _step11.value;

      var _o7 = u(e.get(_n5));

      t.push(_n5), t.push(_o7.contents);
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return t;
}

var Tt = function Tt(e) {
  var t = e.key,
      n = e.get,
      o = e.cacheImplementation_UNSTABLE,
      r = null != e.set ? e.set : void 0;
  var u = null != o ? o : ot();

  function i(o, r) {
    var c;
    var l = r;
    var d = null !== (c = r.nodeDeps.get(t)) && void 0 !== c ? c : wt,
        f = Vt(new Map(Array.from(d).sort().map(function (e) {
      var _ft = ft(o, l, e),
          _ft2 = _slicedToArray(_ft, 2),
          t = _ft2[0],
          n = _ft2[1];

      return l = t, [e, n];
    }))),
        p = u.get(f);
    if (null != p) return [l, p];

    var _ref12 = function (e, o) {
      var r;

      var _ref14 = function (e, o) {
        var r = yt(t);
        var s = o;
        var u = new Map();

        function c(_ref16) {
          var _ref17, _ref18;

          var t = _ref16.key;
          var n;
          if ((_ref17 = (_readOnlyError("s"), ft(e, o, t)), _ref18 = _slicedToArray(_ref17, 2), s = _ref18[0], n = _ref18[1], _ref17), u.set(t, n), "hasValue" === n.state) return n.contents;
          throw n.contents;
        }

        try {
          var _e5 = n({
            get: c
          }),
              _t8 = gt(_e5) ? c(_e5) : _e5,
              _o8 = a(_t8) ? bt(_t8["finally"](r)) : (r(), ht(_t8));

          return [s, _o8, u];
        } catch (t) {
          var _n6 = a(t) ? bt(t.then(function () {
            var t = St(new Error("Internal Recoil Selector Error"));
            if (e.replaceState(function (n) {
              var _i2, _i3;

              var o;
              return (_i2 = i(e, n), _i3 = _slicedToArray(_i2, 2), o = _i3[0], t = _i3[1], _i2), o;
            }), "hasError" === t.state) throw t.contents;
            return t.contents;
          })["finally"](r)) : (r(), St(t));

          return [s, _n6, u];
        }
      }(e, o),
          _ref15 = _slicedToArray(_ref14, 3),
          s = _ref15[0],
          u = _ref15[1],
          c = _ref15[2];

      var l = s;
      var d = null !== (r = o.nodeDeps.get(t)) && void 0 !== r ? r : wt,
          f = new Set(c.keys());
      l = st(d, f) ? l : _objectSpread(_objectSpread({}, l), {}, {
        nodeDeps: ut(l.nodeDeps, t, f)
      });
      var p = ye(f, d),
          S = ye(d, f);

      var _iterator12 = _createForOfIteratorHelper(p),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _e6 = _step12.value;
          l = _objectSpread(_objectSpread({}, l), {}, {
            nodeToNodeSubscriptions: it(l.nodeToNodeSubscriptions, _e6, function (e) {
              return ct(null != e ? e : wt, t);
            })
          });
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      var _iterator13 = _createForOfIteratorHelper(S),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _e7 = _step13.value;
          l = _objectSpread(_objectSpread({}, l), {}, {
            nodeToNodeSubscriptions: it(l.nodeToNodeSubscriptions, _e7, function (e) {
              return lt(null != e ? e : wt, t);
            })
          });
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      return [l, u, c];
    }(o, l),
        _ref13 = _slicedToArray(_ref12, 3),
        S = _ref13[0],
        b = _ref13[1],
        h = _ref13[2];

    l = S;
    var m = Vt(h);
    return function (n, o, r) {
      "loading" !== r.state ? !0 == !e.dangerouslyAllowMutability && s(r.contents) : r.contents.then(function (r) {
        return !0 == !e.dangerouslyAllowMutability && s(r), u = u.set(o, ht(r)), n.fireNodeSubscriptions(new Set([t]), "now"), r;
      })["catch"](function (r) {
        return a(r) || (!0 == !e.dangerouslyAllowMutability && s(r), u = u.set(o, St(r)), n.fireNodeSubscriptions(new Set([t]), "now")), r;
      }), u = u.set(o, r);
    }(o, m, b), [l, b];
  }

  function c(e, t) {
    return i(e, t);
  }

  if (null != r) {
    return vt({
      key: t,
      options: e,
      get: c,
      set: function set(e, t, n) {
        var o = t;
        var a = new Set();

        function s(_ref19) {
          var t = _ref19.key;

          var _ft3 = ft(e, o, t),
              _ft4 = _slicedToArray(_ft3, 2),
              n = _ft4[0],
              r = _ft4[1];

          if (o = n, "hasValue" === r.state) return r.contents;
          throw "loading" === r.state ? new Rt(t) : r.contents;
        }

        function u(t, n) {
          var _pt, _pt2;

          var r = "function" == typeof n ? n(s(t)) : n;
          var u;
          (_pt = pt(e, o, t.key, r), _pt2 = _slicedToArray(_pt, 2), o = _pt2[0], u = _pt2[1], _pt), u.forEach(function (e) {
            return a.add(e);
          });
        }

        return r({
          set: u,
          get: s,
          reset: function reset(e) {
            u(e, mt);
          }
        }, n), [o, a];
      }
    });
  }

  return vt({
    key: t,
    options: e,
    get: c
  });
};

var At = Qe.useRecoilCallback,
    Et = Qe.useRecoilState,
    Mt = Qe.useRecoilStateLoadable,
    Nt = Qe.useRecoilValue,
    _t = Qe.useRecoilValueLoadable,
    Lt = Qe.useResetRecoilState,
    kt = Qe.useSetRecoilState,
    Bt = Qe.useSetUnvalidatedAtomValues,
    Ut = Qe.useTransactionObservation,
    xt = Qe.useTransactionSubscription,
    Ct = T.DefaultValue,
    Ot = ve.RecoilRoot,
    Dt = G.isRecoilValue;
var It = {
  DefaultValue: Ct,
  RecoilRoot: Ot,
  atom: ne,
  selector: Tt,
  useRecoilValue: Nt,
  useRecoilValueLoadable: _t,
  useRecoilState: Et,
  useRecoilStateLoadable: Mt,
  useSetRecoilState: kt,
  useResetRecoilState: Lt,
  useRecoilCallback: At,
  useTransactionObservation_UNSTABLE: Ut,
  useTransactionSubscription_UNSTABLE: xt,
  useSetUnvalidatedAtomValues_UNSTABLE: Bt,
  isRecoilValue: Dt
},
    jt = It.DefaultValue,
    Pt = It.RecoilRoot,
    zt = It.atom,
    qt = It.selector,
    Ft = It.useRecoilValue,
    Wt = It.useRecoilValueLoadable,
    $t = It.useRecoilState,
    Gt = It.useRecoilStateLoadable,
    Kt = It.useSetRecoilState,
    Xt = It.useResetRecoilState,
    Yt = It.useRecoilCallback,
    Ht = It.useTransactionObservation_UNSTABLE,
    Jt = It.useTransactionSubscription_UNSTABLE,
    Qt = It.useSetUnvalidatedAtomValues_UNSTABLE,
    Zt = It.isRecoilValue;
exports.DefaultValue = jt, exports.RecoilRoot = Pt, exports.atom = zt, exports["default"] = It, exports.isRecoilValue = Zt, exports.selector = qt, exports.useRecoilCallback = Yt, exports.useRecoilState = $t, exports.useRecoilStateLoadable = Gt, exports.useRecoilValue = Ft, exports.useRecoilValueLoadable = Wt, exports.useResetRecoilState = Xt, exports.useSetRecoilState = Kt, exports.useSetUnvalidatedAtomValues_UNSTABLE = Qt, exports.useTransactionObservation_UNSTABLE = Ht, exports.useTransactionSubscription_UNSTABLE = Jt;